import { validateCEP } from '@/utils/inputMasks';
import { ValidationRule } from '@/hooks/useFormValidation';

export interface AddressData {
  zipCode: string;
  street: string;
  streetNumber: string;
  complement: string;
  district: string;
  city: string;
  state: string;
  country: string;
}

export const addressValidationRules: ValidationRule<AddressData>[] = [
  {
    field: 'zipCode',
    validate: (value: string) => {
      if (!value) return "CEP é obrigatório";
      if (!validateCEP(value)) return "CEP inválido";
      return null;
    }
  },
  {
    field: 'street',
    validate: (value: string) => {
      if (!value?.trim()) return "Rua é obrigatória";
      return null;
    }
  },
  {
    field: 'streetNumber',
    validate: (value: string) => {
      if (!value?.trim()) return "Número é obrigatório";
      return null;
    }
  },
  {
    field: 'district',
    validate: (value: string) => {
      if (!value?.trim()) return "Bairro é obrigatório";
      return null;
    }
  },
  {
    field: 'city',
    validate: (value: string) => {
      if (!value?.trim()) return "Cidade é obrigatória";
      return null;
    }
  },
  {
    field: 'state',
    validate: (value: string) => {
      if (!value) return "Estado é obrigatório";
      return null;
    }
  }
];
